import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function StorySection() {
  const [ref, visible] = useScrollAnimation();
  const [imgRef, imgVisible] = useScrollAnimation();

  return (
    <section id="story" className="bg-[#0e0e0e] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text content */}
          <div
            ref={ref}
            className={`transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}
          >
            <p
              className="text-white/40 text-xs tracking-[0.3em] uppercase mb-5"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Since 2025
            </p>
            <h2
              className="text-white text-5xl md:text-7xl font-black uppercase leading-none mb-8"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              Our<br />Story
            </h2>

            <div className="space-y-5">
              <p
                className="text-white/60 text-sm leading-[1.9]"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                It all started with a simple question someone asked me: &ldquo;Pete, where can I get the best cheesesteak in town?&rdquo;&nbsp; I didn&apos;t have a good answer, there was nothing I could call my go-to out here. So I told them the only answer that felt right to me, which was that my go-to was here at my house.&nbsp;
              </p>
              <p
                className="text-white/60 text-sm leading-[1.9]"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                What was something that started&nbsp; on a backyard griddle at my house turned into something much more. Word spread, and requests came in just to try these little bundles of joy that reminded me of my home childhood growing up as a kid in Philly.&nbsp;
              </p>
              <p
                className="text-white/60 text-sm leading-[1.9]"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                We&apos;re not trying to reinvent the cheesesteak. We&apos;re just trying to honor it — and do it better than anyone else in this city. No shortcuts. No compromises. Just the real thing, every single time, coming to a neighborhood near you.
              </p>
            </div>

            {/* Stats hidden for now
            <div className="mt-10 flex items-center gap-12">
              {[["2012", "Founded"], ["14+", "Menu Items"], ["4.9★", "Avg. Rating"]].map(([num, label]) => (
                <div key={label}>
                  <p
                    className="text-white text-3xl font-black"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    {num}
                  </p>
                  <p
                    className="text-white/40 text-xs tracking-[0.15em] uppercase mt-0.5"
                  >
                    {label}
                  </p>
                </div>
              ))}
            </div>
            */}
          </div>

          {/* Image */}
          <div
            ref={imgRef}
            className={`transition-all duration-700 delay-200 ${imgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}
          >
            <div className="relative">
              <div className="border-2 border-white/20 rounded-sm overflow-hidden">
                <div className="w-full h-[480px]">
                  <img
                    src="https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/20ebb1fe020d346c51c6bfd78e515bae.jpeg"
                    alt="Inside The Philadelphia Sandwich Company"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              {/* Accent block */}
              <div className="absolute -bottom-5 -right-5 bg-white text-black p-5 rounded-sm">
                <p
                  className="text-black font-black text-xl leading-none"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  100%
                </p>
                <p
                  className="text-black/60 text-xs tracking-widest uppercase mt-0.5"
                  style={{ fontFamily: "'Barlow', sans-serif" }}
                >
                  Local
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
